import React from 'react';
import { formatDistanceToNow, parseISO } from 'date-fns';
import { fr } from 'date-fns/locale'; // Pour la localisation en français

const PublishedDate = ({ published_at }) => {
  // Convertir la chaîne de date en objet Date
  const date = parseISO(published_at);

  // Calculer la distance entre la date actuelle et la date de publication
  const distance = formatDistanceToNow(date, { addSuffix: true, locale: fr });

  return (
    <div className='tag-date legend grey66'>
      {distance}
    </div>
  );
};

export default PublishedDate;